import React, { useState } from 'react';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

const backendUrl = 'http://localhost:3001/api';

const Field: React.FC<{ label: string; value: string; onChange: (v: string) => void; required?: boolean }>
  = ({ label, value, onChange, required }) => (
  <div style={{ marginBottom: 12 }}>
    <label style={{ display: 'block', marginBottom: 4 }}>{label}{required ? ' *' : ''}</label>
    <input value={value} onChange={(e) => onChange(e.target.value)} style={{ width: '100%', padding: 8 }} />
  </div>
);

const MerchantRegistration: React.FC = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [waveAccountId, setWaveAccountId] = useState('');
  const [saved, setSaved] = useState<string>('');

  const submit = async () => {
    const id = uuidv4();
    await axios.post(`${backendUrl}/merchants`, { id, name, email, phone, waveAccountId, status: 'active' });
    setSaved(id);
  };

  return (
    <div style={{ padding: 16, maxWidth: 560 }}>
      <h2>Merchant Registration</h2>
      <p>Provide your basic details to open an account. WAVE account information helps pre-fill transactions.</p>
      <Field label="Business / Merchant Name" value={name} onChange={setName} required />
      <Field label="Email" value={email} onChange={setEmail} required />
      <Field label="Phone" value={phone} onChange={setPhone} required />
      <Field label="WAVE Account ID" value={waveAccountId} onChange={setWaveAccountId} />
      <button onClick={submit} disabled={!name || !email || !phone}>
        Create Account
      </button>
      {saved && (
        <div style={{ marginTop: 12 }}>Registered successfully. Your Merchant ID: <strong>{saved}</strong></div>
      )}
    </div>
  );
};

export default MerchantRegistration;

